"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tweetnacl_1 = __importDefault(require("tweetnacl"));
var tweetnacl_util_1 = require("tweetnacl-util");
var crypto_1 = require("./util/crypto");
var CryptoBase = /** @class */ (function () {
    function CryptoBase() {
        var _this = this;
        /**
         * Generates a new keypair for encryption.
         * @returns The generated keypair.
         */
        this.generate = crypto_1.generateKeypair;
        /**
         * Encrypt given binary file with a unique keypair for each submission.
         * @param binary The file to encrypt, should be a blob that is converted to Uint8Array binary
         * @param publicKey The base-64 encoded public key
         * @returns Promise holding the encrypted file
         * @throws error if any of the encrypt methods fail
         */
        this.encryptFile = function (binary, publicKey) { return __awaiter(_this, void 0, void 0, function () {
            var fileKeypair, nonce;
            return __generator(this, function (_a) {
                fileKeypair = this.generate();
                nonce = tweetnacl_1.default.randomBytes(24);
                return [2 /*return*/, {
                        //! NOTE: submissionPublicKey here is a misnomer as a new keypair is generated per file.
                        // The naming is only retained for backward-compatibility purposes.
                        submissionPublicKey: fileKeypair.publicKey,
                        nonce: (0, tweetnacl_util_1.encodeBase64)(nonce),
                        binary: tweetnacl_1.default.box(binary, nonce, (0, tweetnacl_util_1.decodeBase64)(publicKey), (0, tweetnacl_util_1.decodeBase64)(fileKeypair.secretKey)),
                    }];
            });
        }); };
        /**
         * Decrypt the given encrypted file content.
         * @param secretKey Secret key as a base-64 string
         * @param encrypted Object returned from encryptFile function
         * @param encrypted.submissionPublicKey The file's public key as a base-64 string
         * @param encrypted.nonce The nonce as a base-64 string
         * @param encrypted.blob The encrypted file as a Blob object
         */
        this.decryptFile = function (secretKey, _a) {
            var filePublicKey = _a.submissionPublicKey, nonce = _a.nonce, encryptedBinary = _a.binary;
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    return [2 /*return*/, tweetnacl_1.default.box.open(encryptedBinary, (0, tweetnacl_util_1.decodeBase64)(nonce), (0, tweetnacl_util_1.decodeBase64)(filePublicKey), (0, tweetnacl_util_1.decodeBase64)(secretKey))];
                });
            });
        };
    }
    return CryptoBase;
}());
exports.default = CryptoBase;
